<template>
  <div class="countdown">
    <span>{{ counterValue }}</span>
    <svg class="circle icon-hgradient icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" class=""> 
      </circle>
      <linearGradient id="my-cool-gradient" x2="1" y2="1">
        <stop offset="0%" stop-color="#f7e1a7" />
        <stop offset="25%" stop-color="#e83434" />
        <stop offset="40%" stop-color="#c13939" />
        <stop offset="50%" stop-color="#e83434" />
        <stop offset="60%" stop-color="#c13939" />
        <stop offset="75%" stop-color="#e83434" />
        <stop offset="100%" stop-color="#f7e1a7" />
      </linearGradient>
    </svg>

  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
// eslint-disable-next-line no-undef
const props = defineProps<{
  duration: number,
  callback: any
}>();

let counterValue = props.duration ? ref(props.duration) : ref(15);
const intervalId = setInterval(() => {
  counterValue.value = counterValue.value - 1;
  console.info('counterValue:', counterValue);
  // this.$data.counterValue = this.$data.counterValue -1 ;
  if (counterValue.value === 0) {
    clearInterval(intervalId);
    if (props.callback) {
      props.callback();
    }
  }
}, 1000);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.countdown {
  font-weight: bold;
  font-size: 1.5rem;
  height: 50px;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;


  span {
    display: inline-flex;
    //padding-top: 3px;
    font-weight: inherit;
    z-index: 10;
    line-height: 50px;
  }

  svg.circle {
    position: absolute;
    width: 50px;
    color: rgb(255, 91, 0);
    
  }

  circle{ 
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#efc5ca+0,d24b5a+50,ba2737+51,f18e99+100;Red+Gloss+%233 */
    background: linear-gradient(to bottom,  #efc5ca 0%,#d24b5a 50%,#ba2737 51%,#f18e99 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

  }
   

  
  .icon {
    /* gradient and fallback color */
    fill: url(#my-cool-gradient) #F00;
  }
}
</style>
